import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { TranslateService } from '@ngx-translate/core';
import {ActivatedRoute, Router} from "@angular/router";
import { DashboardComponent } from '../dashboard.component';
import { PartnersComponent } from '../partners/partners.component';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {PageEvent} from '@angular/material/paginator';
import {MatChipInputEvent} from '@angular/material/chips';

import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';

import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';

import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
   dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-purchasecontracts',
  templateUrl: './purchasecontracts.component.html',
  styleUrls: ['./purchasecontracts.component.css'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class PurchasecontractsComponent implements OnInit {
 
  DocumentBodyLoading:boolean;
  loading:boolean;

  loadingDocumentInformation:boolean;
  loadingPCID:string;

  PurchaseContracts:any[];
  Filter: {[k: string]: any} = {};
  Totals: {[k: string]: any} = {};

  ShowDeleteSpendingQuestion:boolean;
  showFilter:boolean;
  partner:any;
  currentPartner:any;

  PaymentCategories:any[];
  BankAccounts:any[];
  PaymentTypes:any[];

  Currencies:any[];
  DocTypes:any[];
  DecimalPrecisions:any[];
  AccountingSeries:any[];
  Administrations:any[];
  MeasuringUnits:any[];
  VATRates:any[];
  ProductGeneralTypes:any[];
  DocumentStatuses:any[];
  Periods:any[];
  currentPayment:{[k: string]: any} = {};

  showEditPartnerPopUp:boolean;

  PurchaseContractPrecision:any;

  SuggestedPayments:any[];
  ShowSuggestionPaymentsContainer:boolean;
  ShowSuggestedPaymentModifier:boolean;
  PaymentTotals:any[];

  currency:any;
  newPartnerCountry:any;
  newPartnerBank:any;
  newPartner:any;

  searchTerm:string;
  resultsLength = 0;
  pageSize = 999999;

  ShowPaymentContainer:boolean;

  Partners:any[];
  countryID:number;
  activeFilters:{[k: string]: any} = [];

  Products:any[];
  CurrentPurchaseContract: {[k: string]: any} = {};

  FromDate = new FormControl(moment());
  ToDate = new FormControl(moment());
  CollectionDate = new FormControl(moment());

  showPurchaseContractVisualizer:boolean;
  searchPartnerUpdate = new Subject<string>();

  constructor(public parent: DashboardComponent, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private route: ActivatedRoute, private router:Router) { 

    translate.addLangs(['en', 'ro', 'de', 'es', 'fr', 'it', 'pl', 'pt']);
    translate.setDefaultLang('en');

    const browserLang = this.parent.getLanguage();
    translate.use(browserLang.match(/en|ro|de|es|fr|it|pl|pt/) ? browserLang : 'en');

    // Debounce search.
    this.searchPartnerUpdate.pipe(
      debounceTime(400),
      distinctUntilChanged())
      .subscribe(value => {
        this.GetPartnersFiltered(value, this.countryID, true);
      });
  }

  ngOnInit(): void {
    this.showFilter = false;
    this.DocumentBodyLoading = false;
    this.InitializeFilter();
    this.GetPurchaseContractsMasterData();
    this.GetPaymentsMasterData();
    this.GetPurchaseContractsFiltered();
    this.countryID = null;
  }

  GetPurchaseContractsMasterData(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    this.parent.loading = true;

    this.service.GetPurchaseContractsMasterData(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Currencies = response["Currencies"];
        this.DocTypes = response["DocTypes"];
        this.DecimalPrecisions = response["DecimalPrecisions"];
        this.AccountingSeries = response["AccountingSeries"];
        this.Administrations = response["Administrations"];
        this.MeasuringUnits = response["MeasuringUnits"];
        this.VATRates = response["VATRates"];
        this.currency = this.Currencies[0];
        this.PurchaseContractPrecision = this.DecimalPrecisions[0];
        this.ProductGeneralTypes = response["ProductGeneralTypes"];
        this.DocumentStatuses = response["DocumentStatuses"];
        this.Periods = response["Periods"];
      }

      this.parent.loading = false;
    });

  }

  GetPaymentsMasterData(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    this.service.GetPaymentsMasterData(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.BankAccounts = response["BankAccounts"];
        this.PaymentTypes = response["PaymentTypes"];
        this.PaymentCategories = response["PaymentCategories"].filter(x => x.ID != -1);
      }
   
      this.parent.loading = false;
    });
  }

  InitializeFilter(){

    this.Filter = {};
    this.Filter.FromDate = null;
    this.Filter.ToDate = null;
    this.Filter.Administration = {};
    this.Filter.AccountingSeries = {};
    this.Filter.Product = "";
    this.Filter.Partner = {};
    this.Filter.DocumentNumber = "";
    this.Filter.DocumentStatus = {};
    this.Filter.Period = {};
    this.Filter.Period = null;

    this.Filter.Pager = {};
    this.Filter.Pager.PageIndex = 1;
    this.Filter.Pager.PageSize = 50;
    this.Filter.Pager.TotalCount = 0;

    this.Filter.ExchangeToTargetCurrency = true;
  }

  ClearPeriod(){
    this.activeFilters = this.activeFilters.filter(x => x.Type != "Period");
    this.Filter.Period = null;

  }

  GetPartnersFiltered(searchTerm:string, CountryID:number, resetPaging:boolean){
    var request = {
      SearchTerm:searchTerm,
      CountryID:CountryID,
      PageIndex:1,
      PageSize:this.pageSize,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Company:this.parent.Company
    };

    if(this.searchTerm.length >= 3){
      this.parent.loading = true;

      this.service.GetPartnersFiltered(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
         this.Partners = response["Partners"];
         this.resultsLength = response["Count"];

         if(this.Partners.length == 1){
          this.partner = this.Partners[0]; this.resultsLength = 0; this.searchTerm = this.Partners[0].Name; this.Filter.Partner = this.Partners[0]; this.AddActiveFilter(this.Partners[0].Name, 'Partner');
          this.GetPurchaseContractsFiltered(1);
         }
        }
     
        this.parent.loading = false;
      });
    }
  }

  InitializePartnersOnClick(searchTerm:string, CountryID:number, resetPaging:boolean){
    var request = {
      SearchTerm:searchTerm,
      CountryID:CountryID,
      PageIndex:1,
      PageSize:10,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Company:this.parent.Company
    };

    if((this.searchTerm.length >= 3) && (this.Partners == null || this.Partners.length == 0)){
      this.parent.loading = true;

      this.service.GetPartnersFiltered(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
         this.Partners = response["Partners"];
         this.resultsLength = response["Count"];
        }
     
        this.parent.loading = false;
      });
    }
    else{
      this.Partners = [];
      this.resultsLength = 0;
    }
  }

  compareFn(c1: any, c2: any): boolean {
    return c1 && c2 ? c1.ID === c2.ID : c1 === c2;
}

  GetPurchaseContractsFiltered(page = 1){

    this.Filter.Pager.PageIndex = page;

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Filter:this.Filter
    };

    if(request.Filter.FromDate != null){
      request.Filter.FromDate = JSON.parse(JSON.stringify(this.FromDate.value._d.toLocaleDateString()));
      this.Filter.FromDate = JSON.parse(JSON.stringify(this.FromDate.value._d.toLocaleDateString()));
    }

    if(request.Filter.ToDate != null){
      request.Filter.ToDate = JSON.parse(JSON.stringify(this.ToDate.value._d.toLocaleDateString()));
      this.Filter.ToDate = JSON.parse(JSON.stringify(this.ToDate.value._d.toLocaleDateString()));
    }
    
    this.loading = true;
    this.showFilter = false;

    this.service.GetPurchaseContractsFiltered(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.PurchaseContracts = response["PurchaseContracts"];
        this.Totals = response["Totals"];

        this.FromDate = new FormControl(moment(this.Filter.FromDate));
        this.ToDate = new FormControl(moment(this.Filter.ToDate));
      }
   
      this.loading = false;
    });

    this.GetPurchaseContractsFilteredCOUNT();

  }

  GetPurchaseContractsFilteredCOUNT(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Filter:this.Filter
    };

    if(request.Filter.FromDate != null){
      request.Filter.FromDate = JSON.parse(JSON.stringify(this.FromDate.value._d.toLocaleDateString()));
      this.Filter.FromDate = JSON.parse(JSON.stringify(this.FromDate.value._d.toLocaleDateString()));
    }

    if(request.Filter.ToDate != null){
      request.Filter.ToDate = JSON.parse(JSON.stringify(this.ToDate.value._d.toLocaleDateString()));
      this.Filter.ToDate = JSON.parse(JSON.stringify(this.ToDate.value._d.toLocaleDateString()));
    }

    this.service.GetPurchaseContractsFilteredCOUNT(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Filter.Pager = response["Pager"];

        this.FromDate = new FormControl(moment(this.Filter.FromDate));
        this.ToDate = new FormControl(moment(this.Filter.ToDate));
      }
   
    });
  }

  ShowDeletePCQuestion:boolean;

  DeletePurchaseContract(purchasecontract:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PurchaseContractID:purchasecontract.ID,
      DetailsID:purchasecontract.Details.ID,
      AccountingNumber:purchasecontract.AccountingNumber
    };

    this.loading = true;

    this.service.DeletePurchaseContract(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
       this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
       this.GetPurchaseContractsFiltered();
       this.showPurchaseContractVisualizer = false;
      }

      this.loading = false;
    });

  }

  ActivatePurchaseContract(purchasecontract:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ID:purchasecontract.ID,
    };

    this.loading = true;

    this.service.ActivatePurchaseContract(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
       this.GetPurchaseContractsFiltered();
       
       if(this.CurrentPurchaseContract != null && this.CurrentPurchaseContract.ID != null){
         this.GetPurchaseContract(this.CurrentPurchaseContract);
       }

      }

      this.loading = false;
    });

  }

  CancelPurchaseContract(purchasecontract:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ID:purchasecontract.ID,
    };

    this.loading = true;

    this.service.CancelPurchaseContract(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
       this.GetPurchaseContractsFiltered();

       if(this.CurrentPurchaseContract != null && this.CurrentPurchaseContract.ID != null){
        this.GetPurchaseContract(this.CurrentPurchaseContract);
      }
      }

      this.loading = false;
    });

  }

  ShowDeactivateDocumentQuestion:boolean;
  ShowReactivateDocumentQuestion:boolean;

  initializePartnerFormFromObject(partner:any){

    this.currentPartner = new FormGroup({

      VAT:new FormControl(partner.VAT),
      UPN:new FormControl(partner.UPN),
      Name:new FormControl(partner.Name, [Validators.required]),
      COCRegNumber:new FormControl(partner.COCRegNumber),
  
      TaxPayer:new FormControl(partner.TaxPayer),
  
      Country:new FormControl(partner.BillingAddress.Country),
      StateProvince:new FormControl(partner.BillingAddress.StateProvince, [Validators.required]),
      City:new FormControl(partner.BillingAddress.City, [Validators.required]),
      AddressLine:new FormControl(partner.BillingAddress.AddressLine, [Validators.required]),
  
      Bank:new FormControl(partner.Bank),
      BankAccount:new FormControl(partner.Bank.BankAccount),
  
      Email: new FormControl(partner.ContactInfo.Email, [Validators.email]),
      ContactName:new FormControl(partner.ContactInfo.Name),
      Phone:new FormControl(partner.ContactInfo.Phone),
    });
   
    this.showEditPartnerPopUp = true;
    this.partner = partner;
  }

  UpdatePartner(){
    var request = {
      Partner:{
        ID:String,
        VAT:this.currentPartner.controls['VAT'].value,
        UPN:this.currentPartner.controls['UPN'].value,
        Name:this.currentPartner.controls['Name'].value,
        COCRegNumber:this.currentPartner.controls['COCRegNumber'].value,

        TaxPayer:this.currentPartner.controls['TaxPayer'].value,

        BillingAddress:{
          ID:Number,
          Country:this.currentPartner.controls['Country'].value,
          StateProvince:this.currentPartner.controls['StateProvince'].value,
          City:this.currentPartner.controls['City'].value,
          AddressLine:this.currentPartner.controls['AddressLine'].value,
        },
        Bank:this.currentPartner.controls['Bank'].value,
        ContactInfo:{
          ID:Number,
          Email:this.currentPartner.controls['Email'].value,
          Name:this.currentPartner.controls['ContactName'].value,
          Phone:this.currentPartner.controls['Phone'].value,
        },
        Company:this.parent.Company,
        EUVATVerified:this.partner.EUVATVerified,
      },
      User:this.parent.User,
      Language:this.parent.getLanguage()
    };

    request.Partner.Bank.BankAccount = this.currentPartner.controls['BankAccount'].value;
    request.Partner.ID = this.partner.ID;
    request.Partner.BillingAddress.ID = this.partner.BillingAddress.ID;
    request.Partner.ContactInfo.ID = this.partner.ContactInfo.ID;

    this.parent.loading = true;

    this.service.UpdatePartner(request).subscribe(response => {
   
      if(response["Status"] != 1){
      
      }
      else if(response["Status"] == 1){
       this.showEditPartnerPopUp = false;
       this.parent.openSnackBar("Partner Updated", "OK", "light-info-snackbar");
       this.partner = response["Partner"];
      }
   
      this.parent.loading = false;
    });
  }

  GetPartnerEUData(partner:any, addnew:boolean){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      VAT:partner.value.VAT,
      CountryCode:partner.value.Country.ShortName
    };

    this.parent.loading = true;

    this.service.GetPartnerEUData(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1 && response["EUVATVerified"] == true){

        if(addnew){

          this.newPartner = new FormGroup({

            VAT:new FormControl(response["VAT"]),
            UPN:new FormControl(''),
            Name:new FormControl(response["Name"], [Validators.required]),
            COCRegNumber:new FormControl(''),
        
            TaxPayer:new FormControl(response["EUVATVerified"]),
        
            Country:new FormControl(response["Country"]),
            StateProvince:new FormControl(''),
            City:new FormControl(''),
            AddressLine:new FormControl(response["Address"], [Validators.required]),
        
            Bank:new FormControl(''),
            BankAccount:new FormControl(''),
        
            Email: new FormControl('', [Validators.email]),
            ContactName:new FormControl(''),
            Phone:new FormControl(''),
          });
        }
        else{

          this.currentPartner = new FormGroup({

            VAT:new FormControl(response["VAT"]),
            UPN:new FormControl(this.partner.UPN),
            Name:new FormControl(response["Name"], [Validators.required]),
            COCRegNumber:new FormControl(this.partner.COCRegNumber),
        
            TaxPayer:new FormControl(response["EUVATVerified"]),
        
            Country:new FormControl(response["Country"]),
            StateProvince:new FormControl(this.partner.BillingAddress.StateProvince, [Validators.required]),
            City:new FormControl(this.partner.BillingAddress.City, [Validators.required]),
            AddressLine:new FormControl(response["Address"], [Validators.required]),
        
            Bank:new FormControl(this.partner.Bank),
            BankAccount:new FormControl(this.partner.Bank.BankAccount),
        
            Email: new FormControl(this.partner.ContactInfo.Email, [Validators.email]),
            ContactName:new FormControl(this.partner.ContactInfo.Name),
            Phone:new FormControl(this.partner.ContactInfo.Phone),
          });

          this.partner.EUVATVerified = response["EUVATVerified"];
        }
      }
   
      this.parent.loading = false;
    });
  }

  ViewPurchaseContract(r:any){

    if(r.DocumentStatus.ID == -1){
      return;
    }

    const nextUrl = this.router.serializeUrl(this.router.createUrlTree(['/dashboard/purchases/contract'], { queryParams: { id: r.ID } }));
    window.open(nextUrl, '_blank');
    // this.router.navigate(['/dashboard/purchases/contract'], { queryParams: { id: r.ID } }); 
  }

  GenerateStorno(r:any){
    const nextUrl = this.router.serializeUrl(this.router.createUrlTree(['/dashboard/purchases/contract'], { queryParams: { id: r.ID, IsStorno: true } }));
    window.open(nextUrl, '_blank');
    // this.router.navigate(['/dashboard/purchases/contract'], { queryParams: { id: r.ID, IsStorno: true } }); 
  }

  GetPurchaseContract(r:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ID:r.ID,
      WithInfo:true,
      ExchangeToTargetCurrency:this.Filter.ExchangeToTargetCurrency,
      IncludeTaxDistributionsInPrice:true
    };

    this.loadingPCID = r.ID;
    this.loadingDocumentInformation = true;

    this.service.GetPurchaseContract(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.CurrentPurchaseContract = response["PurchaseContract"];
        this.CurrentPurchaseContract.Products = this.CurrentPurchaseContract.Products.filter(x => x.ProductPurchaseContractInfo.GeneralType.IsTaxConsumed != true);
        this.showPurchaseContractVisualizer = true;
      }

      this.loadingPCID = null;
      this.loadingDocumentInformation = false;
    });
  }

  ExportPurchaseContract(r:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PurchaseContractID:r.ID,
      BackendServiceUrl:this.parent.BackendServiceUrl
    };

    this.DocumentBodyLoading = true;

    this.service.ExportPurchaseContract(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        var Document = response["Document"];
        this.download(Document.Name, Document.PDFStream);
      }

      this.DocumentBodyLoading = false;
    });
  }

  PrintPurchaseContract(r:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PurchaseContractID:r.ID,
      BackendServiceUrl:this.parent.BackendServiceUrl
    };

    this.DocumentBodyLoading = true;

    this.service.ExportPurchaseContract(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        var Document = response["Document"];
        this.printPage(Document.Name , Document.PDFStream, Document.ID);
      }

      this.DocumentBodyLoading = false;
    });
  }

   printPage(name:string, html:string, ID:string) {
    var winparams = 'dependent=yes,locationbar=no,scrollbars=yes,menubar=yes,' +
    'resizable,screenX=50,screenY=50,width=850,height=1050';

var htmlPop = '<embed width=100% height=100%'
    + ' type="application/pdf"'
    + ' src="data:application/pdf;base64,'
    + escape(html)
    + '"></embed>';

var newWindow = window.open("", 'PDF_' + name +"_"+ ID);
newWindow.document.write(htmlPop);
};

  VizualizeDocument(r:any){
    this.GetPurchaseContract(r);
  }

   download(filename, text) {
    var element = document.createElement('a');
    element.setAttribute('href', 'data:application/pdf;base64,' + encodeURIComponent(text));
    element.setAttribute('download', filename);

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
}

RemoveActiveFilter(ID:string, filterType:string){
    this.activeFilters = this.activeFilters.filter(x => x.ID != ID);

    if(filterType == "Administration"){
      this.Filter.Administration = null;
    }
    else if(filterType == "Series"){
      this.Filter.AccountingSeries = null;
    }
    else if(filterType == "DocStatus"){
      this.Filter.DocumentStatus = null;
    }
    else if(filterType == "DocumentNumber"){
      this.Filter.DocumentNumber = null;
    }
    else if(filterType == "Product"){
      this.Filter.Product = null;
    }
    else if(filterType == "Partner"){
      this.Filter.Partner = null;
    }
    else if(filterType == "Period"){
      this.Filter.Period = null;
    }

    this.GetPurchaseContractsFiltered();
}

  AddActiveFilter(filterName:string, filterType:string){
    var filter = {
      ID:this.parent.newGuid(),
      Name:filterName,
      Type:filterType
    };
    
    if(this.Filter.Administration != null && this.activeFilters.find(x => x.Type == filterType)){
      this.showFilter = false;
      this.GetPurchaseContractsFiltered();
    }

    this.activeFilters = this.activeFilters.filter(x => x.Name != filterName && x.Type != filterType);
    this.activeFilters.push(filter);

    if(filterType == "Period"){
      this.Filter.FromDate = null;
      this.Filter.ToDate = null;

      this.FromDate = new FormControl(moment(this.Filter.FromDate));
      this.ToDate = new FormControl(moment(this.Filter.ToDate));
    }
  }

  DisablePeriod(){
    this.Filter.Period = null;
    this.activeFilters = this.activeFilters.filter(x => x.Type != "Period");
  }

  ExportPurchaseContractsValues(){

    this.Filter.Pager.PageIndex = 1;
  
      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        Filter:this.Filter
      };
  
      if(request.Filter.FromDate != null){
        request.Filter.FromDate = JSON.parse(JSON.stringify(this.FromDate.value._d.toLocaleDateString()));
        this.Filter.FromDate = JSON.parse(JSON.stringify(this.FromDate.value._d.toLocaleDateString()));
      }
  
      if(request.Filter.ToDate != null){
        request.Filter.ToDate = JSON.parse(JSON.stringify(this.ToDate.value._d.toLocaleDateString()));
        this.Filter.ToDate = JSON.parse(JSON.stringify(this.ToDate.value._d.toLocaleDateString()));
      }
      
      this.parent.loading = true;
      this.showFilter = false;
  
      this.service.ExportPurchaseContractsValues(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
        }
        else if(response["Status"] == 1){
          var Document = response["Document"];
        this.download(Document.Name, Document.PDFStream);
        }
     
        this.parent.loading = false;
      });
  }

  ReselectBankAccount(c:any){
    this.currentPayment.BankAccount = this.BankAccounts.filter(x => x.Currency.ID == c.ID)[0];
  }

  ClonePayment(c:any){
    this.currentPayment = JSON.parse(JSON.stringify(c));
  
    this.PaymentCategories.forEach(c => {
      if(c.ID == this.currentPayment.Category.ID){
        this.currentPayment.Category = c;
      }
    });
  
    this.CollectionDate = new FormControl(moment(this.currentPayment.CollectionDate));
  
    if(this.currentPayment.BankAccount == null){
      this.ReselectBankAccount(this.currentPayment.Currency);
    }
  }
  
  DeletePayment(ID:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ID:ID,
    };
  
    this.parent.loading = true;
  
    this.service.DeletePayment(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.SuggestedPayments = this.SuggestedPayments.filter(x => x.ID != ID);
        this.ShowDeleteSpendingQuestion = false;
        this.currentPayment = null;
      }
  
      this.parent.loading = false;
    });
  }

  OpenSuggestedPaymentModifier(c:any){

    this.currentPayment = c;
  
    this.PaymentCategories.forEach(c => {
      if(c.ID == this.currentPayment.Category.ID){
        this.currentPayment.Category = c;
      }
    });
  
    this.CollectionDate = new FormControl(moment(this.currentPayment.CollectionDate));
  
    if(this.currentPayment.BankAccount == null){
      this.ReselectBankAccount(this.currentPayment.Currency);
    }
    
    if(this.currentPayment.PurchaseContractDetailsID == null || this.currentPayment.PurchaseContractDetailsID == undefined){
      this.currentPayment.PurchaseContractDetailsID = "";
    }
  
    if(this.currentPayment.PurchaseContractID == null || this.currentPayment.PurchaseContractID == undefined){
      this.currentPayment.PurchaseContractID = "";
    }
  
    this.CollectionDate = new FormControl(moment(this.currentPayment.PaymentDate));
  
    if(this.currentPayment.BankAccount == null){
      this.ReselectBankAccount(this.currentPayment.Currency);
    }
  }

  SearchedPurchaseContracts:any[];

  SearchPurchaseContracts(s:string){

    if(s.length > 2){
      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        SearchTerm:s,
        WithPartnerInfo:true
      };
  
      this.service.SearchPurchaseContracts(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
        }
        else if(response["Status"] == 1){
          this.SearchedPurchaseContracts = response["PurchaseContracts"];
        }
     
        this.parent.loading = false;
      });
    }
  }

  InitializeNewPayment(r:any){
    this.ShowPaymentContainer = true; 
    this.currentPayment = {};
    this.currentPayment.Type = this.PaymentTypes[1];
    this.currentPayment.Currency = r.Currency;
    this.currentPayment.Currency.DecimalPrecision = this.DecimalPrecisions[0];
    this.CollectionDate = new FormControl(moment());
    this.currentPayment.PaymentDate = JSON.parse(JSON.stringify(this.CollectionDate.value._d.toLocaleDateString()));
    this.CollectionDate = new FormControl(moment(this.currentPayment.CollectionDate));
    this.currentPayment.ID = 0;
  
    this.currentPayment.BankAccount = {};
    this.currentPayment.BankAccount = this.BankAccounts.filter(x => x.Currency.ID == this.currentPayment.Currency.ID)[0];
  
    this.currentPayment.Category = {};
    this.currentPayment.Category = this.PaymentCategories[0];
  
    this.currentPayment.PurchaseContractID = r.ID;
    this.currentPayment.PurchaseContractDetailsID = r.Details.ID;
    this.CurrentPurchaseContract = r;
  }

  AddPayment(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Payment:this.currentPayment,
    };
  
    if(this.CollectionDate.value != null){
      if(this.CollectionDate.value._d != undefined){
        request.Payment.CollectionDate = JSON.parse(JSON.stringify(this.CollectionDate.value._d.toLocaleDateString()));
        this.CollectionDate = JSON.parse(JSON.stringify(this.CollectionDate.value._d.toLocaleDateString()));
      }
      else{
        request.Payment.CollectionDate = JSON.parse(JSON.stringify(this.CollectionDate.value));
        this.CollectionDate = JSON.parse(JSON.stringify(this.CollectionDate.value));
      }
    }
  
    this.parent.loading = true;
  
    this.service.AddPayment(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.GetPurchaseContractsFiltered();
      }
      
  
      this.CollectionDate = new FormControl(moment());
      this.parent.loading = false;
    });
  }

  GenerateReceptionFromPurchaseContract(c){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PurchaseContractID:c.ID,
    };
   
    this.parent.loading = true;
  
    this.service.GenerateReceptionFromPurchaseContract(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      
      this.parent.loading = false;
    });
  }

  AutoPrintDocument(i:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PurchaseContractID:i.ID,
    };
  
    this.DocumentBodyLoading = true;
  
    this.service.ExportPurchaseContract(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        var Document = response["Document"];
        this.parent.AutoPrintDocument(Document);
      }
  
      this.DocumentBodyLoading = false;
    });
  }
  
}
